import React from 'react'
import { formatDateTimeInArabic } from '../../helper/formateDateTimeToArabic';
import { useTranslate } from '../TranslationText';
export default function AuctionDates({ date, label = "label", isWithLabel = true, currentLanguage = 'en' }) {
    const { translate } = useTranslate();
    if (isWithLabel == false) {
        return (
            <>
                {!!date &&
                    <>
                        <i className=" fa fa-calendar C89C66" ></i>
                        <span>
                            {formatDateTimeInArabic(date, currentLanguage)}
                        </span>
                    </>
                }
            </>
        )
    }
    else {
        return (
            <>
                {!!date &&
                    <div className="AuctionDatesStyle">
                        <div>
                            <i className="fa-solid fa-calendar C89C66"></i>
                            <span className="">{translate(`web.${label}`, label)}</span>
                        </div>
                        <div className="rtl">
                            <span className="C89C66">
                                {formatDateTimeInArabic(date, currentLanguage)}
                            </span>
                        </div>
                    </div>
                }
            </>
        );
    }
}

